<template>
  <div class="flex flex-wrap">
    <div class="w-full px-4">
      <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
        <div class="rounded-t bg-white mb-0 px-6 py-6">
          <div class="text-center flex justify-between">
            <h6 class="text-blueGray-700 text-xl font-bold">API Playground</h6>

          </div>
        </div>
        <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
          <form>
            <div class="w-full lg:w-12/12 px-4">
              <div class="relative w-full mb-3">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2 mt-5" htmlFor="grid-password">
                  Client Token
                </label>
                <input type="text" placeholder="Put your Client Token here" v-model="clientId"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
              </div>
            </div>

            <div class="w-full lg:w-12/12 px-4">
              <div class="relative w-full mb-3">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2 mt-5" htmlFor="grid-password">
                  Request
                </label>
                <JsonEditorVue v-model="value" mode="text" v-bind="{/* local props & attrs */ }" />
              </div>
            </div>
            <div class="w-full lg:w-12/12 px-4 flex">
              <div class=" w-10/12 mb-3">
                <div class="flex items-start" v-if="isPlayground">
                  <div class="flex h-5 items-center">
                    <input id="comments" name="comments" type="checkbox" v-model="is_save"
                      class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500" />
                  </div>
                  <div class="ml-3 text-sm">
                    <label for="comments" class="font-medium text-gray-700">Save Request?</label>
                    <p class="text-gray-500">Save Request to use it later.</p>
                  </div>
                </div>
              </div>
              <div class=" w-2/12 mb-3 text-right">
                <button
                  class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                  :onClick="requestAPI" type="button">
                  Submit
                </button>
              </div>

            </div>
            <div class="w-full lg:w-12/12 px-4">
              <div class="relative w-full mb-3">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2 mt-5" htmlFor="grid-password">
                  Response
                </label>
                <JsonEditorVue v-model="api_response" :mainMenuBar=false mode="text"
                  v-bind="{/* local props & attrs */ }" :readOnly=true />

              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import { UseAppStore } from '@/stores/AppStore';
import JsonEditorVue from 'json-editor-vue'
import ApiPlaygroundService from "@/services/ApiPlaygroundService";
import ErrorHandler from "@/ErrorHandler";

export default {
  setup() {
    const appStore = UseAppStore();
    appStore.resetBreadcrumbs();
    appStore.putBreadcrumbs("dashboard", "Dashboard", "/admin/dashboard")
    appStore.putBreadcrumbs("api", "API Playground", "/admin/api-playground")
    return {
      appStore
    }
  },
  props: {
    pageType: String,
    valueProps: { type: Object }
  },
  data() {
    return {
      isPlayground: !(this.pageType == 'edit_request' || this.pageType == 'new_request'),
      is_save: (this.pageType == 'edit_request' || this.pageType == 'new_request'),
      // value: undefined
      // ,
      value: {
        "client_name": "",
        "app_name": "",
        "version": "",
        "intention": "",
        "authorization_forward": "",
        "payload": {},
        "headers": {}
      }
      ,
      api_response: undefined,
      clientId: '' //'PAXEL-123123123'
    };
  },
  watch: {
    valueProps: function (newVal, oldVal) { // watch it
      console.log('Prop changed: ', newVal, ' | was: ', oldVal)
      if (newVal != undefined) {
        this.value = newVal
      }
    }
  },
  methods: {
    requestAPI() {

      console.log(this.value)
      ApiPlaygroundService.create(this.value, this.clientId, this.is_save)
        .then((response) => {
          this.api_response = response.data;
          this.alertType = 'Success'
          this.alertMessage = 'Client successfuly created'
          //   this.$router.replace('/admin/clients')
          // if (!this.isPlayground) {
          //   document.location = '/admin/api-requests'
          // }
        })
        .catch(e => {
          console.log(e)
          ErrorHandler(e)
        });
    }
  },
  components: {
    JsonEditorVue
  },
};
</script>
